// Proveedor de contenido local para el modo offline (VUE_APP_OFFLINE_MODE=true).
// Devuelve los items en la misma forma que usa HomePlayer.vue cuando consume
// schedule/getScheduleList, para que el componente no necesite distinguir
// entre origen remoto y local.

const MANIFEST_URL = `${process.env.BASE_URL}offline-content/manifest.json`

export const isOfflineMode = () => process.env.VUE_APP_OFFLINE_MODE === 'true'

// horario = { inicio: "07:00", fin: "23:00" }. Sin horario definido, se
// muestra siempre (mismo criterio que usaba el schedule remoto por defecto).
const isWithinSchedule = (horario) => {
    if (!horario?.inicio || !horario?.fin) return true

    const now = new Date()
    const current = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`

    return current >= horario.inicio && current <= horario.fin
}

export const getOfflineContents = async () => {
    const response = await fetch(MANIFEST_URL, { cache: 'no-store' })
    if (!response.ok) {
        throw new Error(`No se pudo cargar el manifest offline (${response.status})`)
    }

    const manifest = await response.json()

    if (!isWithinSchedule(manifest.horario)) {
        return []
    }

    const items = manifest?.items || []

    return items.map((item) => ({
        id_detalle: item.id_detalle,
        duracion: item.duracion,
        contenido: {
            nombre: item.nombre,
            proximamente: 'No',
            orientacion: manifest.orientacion,
            archivo: item.archivo
        }
    }))
}
